export default __webpack_public_path__ + "static/media/earth.db6e1746.svg";